export const paramsTraductions = {
    en: {
        add: 'Ajouter',
        addAdmin: 'Add administrator',
        addind: 'Ajout...',
        admin: 'Administrateur',
        allAdmin: 'Tous les administrateurs',
        confirm: 'Confirmez votre mot de passe',
        delete: 'Supprimer',
        email: 'Email',
        editProfile: 'Editer un profil',
        logout: 'Se déconnecter',
        noAdmin: 'Aucun admin pour l\'instant',
        password: 'Mot de passe',
        teacher: 'Enseignant',
        username: 'Pseudo',
        saving: 'Enregistrement',
        save: 'Enregistrer',
        role: 'Rôle',
        cancel: 'Annuler',
        selectSex: '--- Selectionner le sexe de l\'enseignant ----',
        m: 'Masculin',
        comptable: 'Comptable',
        f: 'Féminin',
        sex: 'Sex de l\'enseignant',
        teacherName: 'Nom de l\'enseignagnt :',
        teacherSubname: 'Prénom de l\'ensignant :',
        allComp: 'Tous les comptables',
        noComp: 'Aucun comptable pour l\'instant',
        selectRole: 'Sélectionnez un rôle',
        number: 'Numéro de téléphone de l\'enseignant :',
    },
    fr: {
        add: 'Ajouter',
        addAdmin: 'Ajouter un administrateur',
        addind: 'Ajout...',
        admin: 'Administrateur',
        allAdmin: 'Tous les administrateurs',
        confirm: 'Confirmez votre mot de passe',
        delete: 'Supprimer',
        selectRole: 'Sélectionnez un rôle',
        email: 'Email',
        editProfile: 'Editer un profil',
        logout: 'Se déconnecter',
        allComp: 'Tous les comptables',
        noComp: 'Aucun comptable pour l\'instant',
        noAdmin: 'Aucun admin pour l\'instant',
        password: 'Mot de passe',
        teacher: 'Enseignant',
        role: 'Rôle',
        username: 'Pseudo',
        saving: 'Enregistrement',
        save: 'Enregistrer',
        cancel: 'Annuler',
        comptable: 'Comptable',
        selectSex: '--- Selectionner le sexe de l\'enseignant ----',
        m: 'Masculin',
        f: 'Féminin',
        sex: 'Sex de l\'enseignant',
        teacherName: 'Nom de l\'enseignagnt :',
        teacherSubname: 'Prénom de l\'ensignant :',
        number: 'Numéro de téléphone de l\'enseignant :',
    }
}